import { AdditionalFacilitiesFormFields, FormInput } from 'src/@types';
import { getDefaultValue } from 'src/components/shared/form-elements';
import { utilNumberToCurrency } from '../../../../../utils';

export const additionalFacilitiesFormFields: Record<
  keyof AdditionalFacilitiesFormFields,
  FormInput
> = {
  employerName: {
    fieldName: 'employerName',
    label: 'Naam werkgever',
    type: 'text',
    tooltip:
      'Vul de volledige naam in van de organisatie waarmee de medewerker de arbeidsovereenkomst heeft (geen handelsnaam).',
    defaultValue: getDefaultValue('employerName')
  },
  employerAddress: {
    fieldName: 'employerAddress',
    label: 'Adres werkgever',
    type: 'text',
    tooltip: 'Vul het adres van de organisatie in. Een postbusnummer is niet toegestaan.',
    defaultValue: getDefaultValue('employerAddress')
  },
  employerPostCode: {
    fieldName: 'employerPostCode',
    label: 'Postcode',
    type: 'text',
    defaultValue: getDefaultValue('1234 AD')
  },
  employerPlace: {
    fieldName: 'employerPlace',
    label: 'Plaats',
    type: 'text',
    tooltip: 'De postcode moet horen bij het adres.',
    defaultValue: getDefaultValue('employerPlace')
  },
  contactPerson: {
    fieldName: 'contactPerson',
    label: 'Contactpersoon (Ingevuld door)',
    type: 'text',
    tooltip: 'De contactpersoon, door wie ingevuld?',
    defaultValue: getDefaultValue('contactPerson')
  },
  contactPersonPhoneNumber: {
    fieldName: 'contactPersonPhoneNumber',
    label: 'Telefoonnummer contactpersoon',
    type: 'tel',
    defaultValue: getDefaultValue('0624237484')
  },
  employeeName: {
    fieldName: 'employeeName',
    label: 'Naam werknemer',
    type: 'text',
    defaultValue: getDefaultValue('employeeName')
  },
  employeeAddress: {
    fieldName: 'employeeAddress',
    label: 'Adres werknemer',
    type: 'text',
    defaultValue: getDefaultValue('employeeAddress')
  },
  employeePostCode: {
    fieldName: 'employeePostCode',
    label: 'Postcode',
    type: 'text',
    defaultValue: getDefaultValue('123456789')
  },
  employeePlace: {
    fieldName: 'employeePlace',
    label: 'Woonplaats',
    type: 'text',
    defaultValue: getDefaultValue('employeePlace')
  },
  informationRequestedCanNotBeProvidedToTheEmployee: {
    fieldName: 'informationRequestedCanNotBeProvidedToTheEmployee',
    label: '',
    type: 'checkbox',
    options: [
      {
        label: 'Ik kan de hieronder gevraagde gegevens niet aan mijn werknemer verstrekken.',
        value: 'true'
      }
    ],
    defaultValue: getDefaultValue('informationRequestedCanNotBeProvidedToTheEmployee')
  },
  doesTheCompanyHasCollectiveLifeInsurancePolicy: {
    fieldName: 'doesTheCompanyHasCollectiveLifeInsurancePolicy',
    label: 'Heeft uw bedrijf een collectieve overlijdensverzekering afgesloten?',
    type: 'radio',
    tooltip:
      'Deze verzekering zorgt voor een extra jaarlijkse uitkering (aan de nabestaanden) bij overlijden van de medewerker. Dit is een zogenaamde Anw-hiaat verzekering.',
    options: [
      { label: 'Ja', value: 'true' },
      {
        label: 'Nee, medewerker sluit op vrijwillige basis een ANW-hiaatverzekering af.',
        value: 'false'
      }
    ],
    defaultValue: getDefaultValue('true')
  },
  isTheEmployeeInsuredByAnwInsurance: {
    fieldName: 'isTheEmployeeInsuredByAnwInsurance',
    label: 'Is deze medewerker verzekerd door een ANW-hiaat verzekering?',
    type: 'radio',
    options: [
      { label: 'Ja', value: 'true' },
      { label: 'Nee', value: 'false' }
    ],
    defaultValue: getDefaultValue('true')
  },
  annualPaymentOfTheAnwInsurance: {
    fieldName: 'annualPaymentOfTheAnwInsurance',
    label: 'Hoe hoog is de jaarlijkse uitkering?',
    type: 'currency',
    defaultValue: getDefaultValue(utilNumberToCurrency(12345678, true))
  },
  anwBenefitStartingStatement: {
    fieldName: 'anwBenefitStartingStatement',
    label: 'De uitkering uit de Anw-hiaatverzekering start:',
    type: 'radio',
    options: [
      {
        label: 'Direct na het overlijden van de werknemer',
        value: 'Direct na het overlijden van de werknemer'
      },
      {
        label: 'Op het moment dat het jongste kind de leeftijd van 18 jaar bereikt.',
        value: 'Op het moment dat het jongste kind de leeftijd van 18 jaar bereikt'
      }
    ],
    defaultValue: getDefaultValue('Direct na het overlijden van de werknemer')
  },
  percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf: {
    fieldName: 'percentageOfWagesDuringIllnessInTheFirstYearTheFirstHalf',
    label: 'Eerste half jaar',
    type: 'percentage',
    defaultValue: getDefaultValue('20')
  },
  percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf: {
    fieldName: 'percentageOfWagesDuringIllnessInTheFirstYearTheSecondHalf',
    label: 'Tweede half jaar',
    type: 'percentage',
    defaultValue: getDefaultValue('30')
  },
  percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf: {
    fieldName: 'percentageOfWagesDuringIllnessInTheSecondYearTheFirstHalf',
    label: 'Eerste half jaar',
    type: 'percentage',
    defaultValue: getDefaultValue('40')
  },
  percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf: {
    fieldName: 'percentageOfWagesDuringIllnessInTheSecondYearTheSecondHalf',
    label: 'Tweede half jaar',
    type: 'percentage',
    defaultValue: getDefaultValue('50')
  },
  wagesPercentageComposition: {
    fieldName: 'wagesPercentageComposition',
    label: 'De loondoorbetaling is een percentage van',
    type: 'radio',
    tooltip:
      'Dit kan zijn als onderdeel van de pensioenregeling. Of rechtstreeks bij uw arbeidsongeschiktheidsverzekeraar.',
    options: [
      { label: 'Het salaris', value: 'Het salaris' },
      {
        label: 'Het salaris gemaximeerd op de WIA-loongrens',
        value: 'Het salaris gemaximeerd op de WIA-loongrens'
      }
    ],
    defaultValue: getDefaultValue('Het salaris')
  },
  haveYouTakenOutWiaInsuranceForYourEmployees: {
    fieldName: 'haveYouTakenOutWiaInsuranceForYourEmployees',
    label: 'Heeft u voor uw werknemers een collectieve aanvullende WIA-verzekering gesloten?',
    type: 'radio',
    options: [
      { label: 'Ja', value: 'true' },
      { label: 'Nee', value: 'false' }
    ],
    tooltip:
      'Dit kan zijn als onderdeel van de pensioenregeling. Of rechtstreeks bij uw arbeidsongeschiktheidsverzekeraar.',
    defaultValue: getDefaultValue('true')
  },
  wgaGapInsuranceClass: {
    fieldName: 'wgaGapInsuranceClass',
    label: 'Heeft u een WGA Hiaat verzekering voor uw medewerker gesloten?',
    type: 'radio',
    options: [
      { label: 'WGA-Hiaat Basis', value: 'WGA-Hiaat Basis' },
      { label: 'WGA-Hiaat Uitgebreid', value: 'WGA-Hiaat Uitgebreid' },
      { label: 'Nee', value: 'false' }
    ],
    tooltip:
      '<b>Korte uitleg: WGA-Hiaat Basis</b><br/>' +
      'De WGA-regeling is voor werknemers die gedeeltelijk arbeidsgeschikt zijn. Het staat voor Werkhervattingsregeling Gedeeltelijk Arbeidsgeschikten. Een WGA-Hiaatverzekering is een collectieve WGA-verzekering die arbeidsongeschikte werknemers een aanvulling op de wettelijke uitkering (de Vervolguitkering) geeft. Met een WGA-hiaatverzekering (basisvariant) krijgt een werknemer die (gedeeltelijk) arbeidsongeschikt is,' +
      '<br/><br/>' +
      '<b>Korte uitleg: WGA-Hiaat Uitgebreid</b><br/>' +
      'De collectieve WGA-hiaatverzekering Uitgebreid zorgt ervoor dat het inkomen van een werknemer die een WGAloonaanvullingsuitkering, of WGA-vervolguitkering ontvangt, wordt aangevuld tot 70 procent van het loon dat hij verdiende voordat hij ziek werd. Dit loon mag niet meer zijn dan het maximumloon, ofwel sv-loon',
    defaultValue: getDefaultValue('WGA-Hiaat Uitgebreid')
  },
  durationOfTheWgaHiaatInsuranceStatement: {
    fieldName: 'durationOfTheWgaHiaatInsuranceStatement',
    label: 'Hoe lang is de uitkeringsduur van de aangekruiste WGA-Hiaat verzekering?',
    type: 'radio',
    options: [
      { label: 'Tot AOW-gerechtigde leeftijd', value: 'Tot AOW-gerechtigde leeftijd' },
      { label: 'Anders', value: 'Other' }
    ],
    defaultValue: getDefaultValue('Tot AOW-gerechtigde leeftijd')
  },
  durationOfTheWgaHiaatInsuranceStatementOther: {
    fieldName: 'durationOfTheWgaHiaatInsuranceStatementOther',
    label: 'Hoeveel jaar',
    type: 'number',
    defaultValue: getDefaultValue('12')
  },
  haveYouTakenOutTheWiaExcessInsurance: {
    fieldName: 'haveYouTakenOutTheWiaExcessInsurance',
    label: 'Heeft u voor uw medewerker een WIA-Excedentverzekering afgesloten?',
    type: 'radio',
    options: [
      { label: 'Ja', value: 'true' },
      { label: 'Nee', value: 'false' }
    ],
    tooltip:
      '<b>Korte uitleg: WIA-Excedent (vanaf de WIA-loongrens)</b><br/>' +
      'De WIA-Excedentverzekering (vanaf de WIA-loongrens) beschermt werknemers met een loon boven de WIA-loongrens tegen inkomensverlies (als gevolg van arbeidsongeschiktheid). Door een periodieke aanvullende verzekeringsuitkering, die afhankelijk is van de mate van arbeidsongeschiktheid, wordt dit verlies samen met de wettelijke uitkeringen deels opgevangen. Dit is veelal tot 70 of tot 80% van het verschil tussen het oude loon en het gemaximeerde loon.',
    defaultValue: getDefaultValue('true')
  },
  durationOfTheWiaExcessInsuranceStatement: {
    fieldName: 'durationOfTheWiaExcessInsuranceStatement',
    label: 'Wat is de looptijd van de WIA-Excedentverzekering? ',
    type: 'radio',
    options: [
      { label: 'Tot AOW-gerechtigde leeftijd', value: 'Tot AOW-gerechtigde leeftijd' },
      { label: 'Anders', value: 'Other' }
    ],
    defaultValue: getDefaultValue('Other')
  },
  durationOfTheWiaExcessInsuranceStatementOther: {
    fieldName: 'durationOfTheWiaExcessInsuranceStatementOther',
    label: 'Hoeveel jaar',
    type: 'number',
    defaultValue: getDefaultValue('12')
  },
  theCoveragePercentageOfTheWiaExcessInsurance: {
    fieldName: 'theCoveragePercentageOfTheWiaExcessInsurance',
    label: 'Hoe hoog is het dekkingspercentage van de WIA-Excedentverzekering?',
    type: 'radio',
    options: [
      { label: '70%', value: '70' },
      { label: '80%', value: '80' },
      { label: '80% x ao%', value: '80ao' },
      { label: 'Anders', value: 'Other' }
    ],
    defaultValue: getDefaultValue('Other')
  },
  theCoveragePercentageOfTheWiaExcessInsuranceOther: {
    fieldName: 'theCoveragePercentageOfTheWiaExcessInsuranceOther',
    label: '',
    type: 'percentage',
    defaultValue: getDefaultValue('50')
  },
  haveYouTakenOutTheWiaIncomeSupplement: {
    fieldName: 'haveYouTakenOutTheWiaIncomeSupplement',
    label: 'Heeft u voor uw medewerker een WIA-Inkomensaanvulling afgesloten?',
    type: 'radio',
    options: [
      { label: 'Ja', value: 'true' },
      { label: 'Nee', value: 'false' }
    ],
    defaultValue: getDefaultValue('true')
  },
  durationOfTheWiaIncomeSupplementStatement: {
    fieldName: 'durationOfTheWiaIncomeSupplementStatement',
    label: 'Wat is de looptijd van de WIA-Inkomensaanvulling?',
    type: 'radio',
    options: [
      { label: 'Tot AOW-gerechtigde leeftijd', value: 'Tot AOW-gerechtigde leeftijd' },
      { label: 'Anders', value: 'Other' }
    ],
    defaultValue: getDefaultValue('Other')
  },
  durationOfTheWiaIncomeSupplementStatementOther: {
    fieldName: 'durationOfTheWiaIncomeSupplementStatementOther',
    label: 'Hoeveel jaar',
    type: 'number',
    defaultValue: getDefaultValue('12')
  },
  theCoveragePercentageOfTheWiaIncomeSupplement: {
    fieldName: 'theCoveragePercentageOfTheWiaIncomeSupplement',
    label: 'Hoe hoog is het dekkingspercentage van de WIA-Inkomensaanvulling',
    type: 'radio',
    options: [
      { label: '10%', value: '10' },
      { label: 'Anders', value: 'Other' }
    ],
    defaultValue: getDefaultValue('Other')
  },
  theCoveragePercentageOfTheWiaIncomeSupplementOther: {
    fieldName: 'theCoveragePercentageOfTheWiaIncomeSupplementOther',
    label: '',
    type: 'percentage',
    defaultValue: getDefaultValue('40')
  },
  signatureName: {
    fieldName: 'signatureName',
    label: 'Naam ondertekenaar',
    type: 'text',
    defaultValue: getDefaultValue('signatureName')
  },
  signedAt: {
    fieldName: 'signedAt',
    label: 'Getekend te',
    type: 'text',
    defaultValue: getDefaultValue('signedAt')
  },
  dateOfSignature: {
    fieldName: 'dateOfSignature',
    label: 'Datum ondertekening',
    type: 'date',
    defaultValue: getDefaultValue('2023-09-27')
  }
};
